<div class="faq">

  <h1>NAJCZĘŚCIEJ ZADAWANE PYTANIA</h1>

  <div class="accordion">
    <div class="accordion-item">
      <input type="checkbox" id="chck1">
      <label class="accordion-item-label" for="chck1">Kiedy otrzymam zamówioną nagrodę?</label>
      <div class="accordion-item-content">
        Nagroda zostanie doręczona maksymalnie do 10 dni roboczych.
      </div>
    </div>
    <div class="accordion-item">
      <input type="checkbox" id="chck2">
      <label class="accordion-item-label" for="chck2">Uzbierałem 50 zł premii. Czy mogę je wymienić na przelew?</label>
      <div class="accordion-item-content">
        Tak! Wystarczy uzbierać 50 zł premii aby zamówić przelew. Wejdź w zakładkę „Przelew” i dokonaj zamówienia.
      </div>
    </div>
    <div class="accordion-item">
      <input type="checkbox" id="chck3">
      <label class="accordion-item-label" for="chck3">Czy zapłacę podatek od nagród w programie?</label>
      <div class="accordion-item-content">
        Zgodnie z obowiązującymi przepisami podatek od nagród odprowadza Uczestnik.
        Jeśli bierzesz udział w Programie jako osoba fizyczna nieprowadząca działalność gospodarczą, otrzymasz od nas PIT-11 po zakończeniu roku.
        Jeśli prowadzisz działalność gospodarczą, wartość nagrody należy rozliczyć jako przychód z wykonywanej działalności.
      </div>
    </div>
    <div class="accordion-item">
      <input type="checkbox" id="chck4">
      <label class="accordion-item-label" for="chck4">Otrzymałem informację, że moja premia została przeterminowana. Dlaczego?</label>
      <div class="accordion-item-content">
        Jeśli nie wykorzystasz premii w ciągu 3 miesięcy od ich otrzymania, premie ulegają przeterminowaniu i zostają odjęte z konta.
      </div>
    </div>

    <div class="accordion-item">
      <input type="checkbox" id="chck5">
      <label class="accordion-item-label" for="chck5">Wczoraj wykonałem Premiowaną Transakcję, dlaczego nie widzę jej na swoim koncie?</label>
      <div class="accordion-item-content">
        Poczekaj aż zaktualizujemy Twój wynik. Wyniki sprzedażowe aktualizowane są średnio raz na tydzień a co najmniej raz w miesiącu.
      </div>
    </div>
    <div class="accordion-item">
      <input type="checkbox" id="chck6">
      <label class="accordion-item-label" for="chck6">Gdzie mogę sprawdzić jakie zdobyłem premie?</label>
      <div class="accordion-item-content">
        Spis wszystkich naliczonych premii za Zadania Dnia oraz Premiowane Transakcje znajduje się w zakładce Przelewy –> Historia operacji.
      </div>
    </div>
    <div class="accordion-item">
      <input type="checkbox" id="chck7">
      <label class="accordion-item-label" for="chck7">Zdobyłem premię za Zadanie Dnia, ale nie mogę jej wypłacić. Dlaczego?</label>
      <div class="accordion-item-content">
        Premia będzie dostępna po wykonaniu minimum 3 Premiowanych Transakcji.
      </div>
    </div>
    <div class="accordion-item">
      <input type="checkbox" id="chck8">
      <label class="accordion-item-label" for="chck8">Zdobyłem Czasowy Bonus Sprzedażowy ale nie widzę go na swoim koncie. Dlaczego?</label>
      <div class="accordion-item-content">
        Czasowy Bonus Sprzedażowy działa już w dniu zdobycia, ale na konto zostanie naliczony razem z premią za wykonanie Premiowanej Transakcji.
      </div>
    </div>
    <div class="accordion-item">
      <input type="checkbox" id="chck9">
      <label class="accordion-item-label" for="chck9">Chcę zrezygnować z uczestnictwa w programie. Jak mogę usunąć swoje konto?</label>
      <div class="accordion-item-content">
        Aby usunąć konto wystarczy wejść do zakładki Moje konto, następnie Moje dane i kliknąć Usuń Konto na dole sekcji.
      </div>
    </div>
  </div>

</div>
